import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PluginObject } from 'vue/types/umd';
import { BehaviorSubject } from 'rxjs';

import * as lantern from '@lantern/lantern-sdk';

import { Sites, Inmates, Facilities, User, Courses } from '@lantern/lantern-sdk';

export enum LocalStorageKeys {
    AuthToken = 'authToken',
    PermissionToken = 'permissionToken',
    RefreshToken = 'refresh_token',
    TokenExpirey = 'tokenExpirey',
    PollForToken = 'pollForToken',
}

export enum Titles {
    studentsOnly = 'studentsOnly',
    studentsEnrollment = 'studentsEnrollment',
    cvsFile = 'cvsFile'
}

export interface NewEnrollmentData {
    facilityPK: string;
    inmates: lantern.Sessions.InmateEnrollment[];
    registrationCount: number;
    studentCount: number;
}

interface InmateEnrollmentsConfirmation extends lantern.Sessions.InmateEnrollment {
    inmate: Inmates.Document;
}

export interface NewEnrollmentConfirmationData {
    facilityPK: string;
    inmates: InmateEnrollmentsConfirmation[];
    registrationCount: number;
    studentCount: number;
}

export interface CacheOptions {}

interface CacheConstructorOptions {}

export interface InmateSelected {
    [siteID: string]: string[];
}

export interface CourseListItem extends Courses.Course {
    selected: boolean;
    sections: Courses.Section[] | [];
    pickedSection: Courses.Section | null;
}

export interface CoursesSelected {
    [course: string]: CourseListItem;
}

@Component
export class Cache extends Vue {
    private static _instance: Cache;
    private static options: CacheConstructorOptions;

    public static CachePlugin: PluginObject<CacheOptions> = {
        install(vue: Vue.VueConstructor<Vue>, options: CacheOptions = {}) {
            Cache.options = {
                ...options
            };
            (<any>vue).prototype.$cache = Cache.instance;
        }
    };

    public static get instance() {
        if (!this._instance) Cache._instance = new Cache();
        return Cache._instance;
    }

    public facility = new BehaviorSubject<Facilities.Document | null>(null);
    public facilities = new BehaviorSubject<Facilities.Document[]>([]);
    public user = new BehaviorSubject<User.Info | null>(null);
    public isAdmin = new BehaviorSubject<boolean | null>(null);
    public inmatesSelected = new BehaviorSubject<InmateSelected | {}>({});
    public accounts = new BehaviorSubject<lantern.User.CanvasAccounts | { mainAccounts: []; subAcccounts: [] }>({ mainAccounts: [], subAcccounts: [] });
    public coursesSelected = new BehaviorSubject<CoursesSelected | {}>({});
    public cvsFileData = new BehaviorSubject<NewEnrollmentData | null>(null);
    public coursesArray = new BehaviorSubject<CourseListItem[] | []>([]);

}
